// extracted by mini-css-extract-plugin
export default {"noScroll":"Modal_noScroll__Qpqlu","modal":"Modal_modal__yEgVW","modalBlock":"Modal_modalBlock__cOFps","modalClose":"Modal_modalClose__2t+lb"};